import { render } from "./QR_Redirect.vue?vue&type=template&id=78100536"
import script from "./QR_Redirect.vue?vue&type=script&lang=js"
export * from "./QR_Redirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__